// extracted by mini-css-extract-plugin
export default {"creditbtn":"sudexo_creditbtn__0K5U9"};